export default __webpack_public_path__ + "static/media/tick.3f3f995a.png";